import React from 'react';

import type { Role } from '../../api/types';

type RoleBadgeConfig = {
  icon: string;
  className: string;
  label: string;
};

const ROLE_CONFIG: Record<Role, RoleBadgeConfig> = {
  admin: { icon: '\uD83D\uDC51', className: 'mi-role-badge--admin', label: 'Администратор' },
  organizer: { icon: '\u2694\uFE0F', className: 'mi-role-badge--organizer', label: 'Организатор' },
  user: { icon: '\uD83D\uDEE1\uFE0F', className: 'mi-role-badge--user', label: 'Пользователь' },
};

type Props = {
  role: Role;
  hasClubKey?: boolean;
};

export const RoleBadge = React.memo(function RoleBadge({ role, hasClubKey = false }: Props) {
  const config = ROLE_CONFIG[role];
  return (
    <>
      <span
        className={`mi-role-badge ${config.className}`}
        aria-label={config.label}
        title={config.label}
      >
        <span aria-hidden="true">{config.icon}</span>
      </span>
      {hasClubKey && (
        <span className="mi-key-icon" aria-label="Есть ключ от клуба" title="Есть ключ от клуба">
          <span aria-hidden="true">{'\uD83D\uDDDD\uFE0F'}</span>
        </span>
      )}
    </>
  );
});
